/**
 * Common validation patterns used across the application
 */

export const EMAIL_PATTERN = /^(?!.*,)\S+@\S+\.\S+$/i;

/**
 * Phone pattern: allows optional + prefix, digits, parentheses, hyphens, and spaces
 * Minimum 4 characters
 */
export const PHONE_PATTERN = /^\+?[0-9()\-\s]{4,}$/;

/**
 * URL pattern: validates http(s):// URLs with domain or IP address
 * Supports: http://example.com, https://sub.domain.org/path, http://10.0.0.1:8080/path?query=1
 */
export const URL_PATTERN =
  /^https?:\/\/((([a-z\d]([a-z\d-]*[a-z\d])*)\.)+[a-z]{2,}|((\d{1,3}\.){3}\d{1,3}))(:\d+)?(\/[-a-z\d%@_.~+&:]*)*(\?[;&a-z\d%@_.,~+&:=-]*)?(#[-a-z\d_]*)?$/i;
